import { render, staticRenderFns } from "./AirportDetail.vue?vue&type=template&id=1a4367e6&scoped=true&"
import script from "./AirportDetail.vue?vue&type=script&lang=js&"
export * from "./AirportDetail.vue?vue&type=script&lang=js&"
import style0 from "./AirportDetail.vue?vue&type=style&index=0&id=1a4367e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4367e6",
  null
  
)

export default component.exports